import { formatCurrency } from "@angular/common";
import type { ChartConfiguration } from "chart.js";

export const lineChartDefaultOptions: ChartConfiguration["options"] = {
  responsive: true,
  maintainAspectRatio: true,
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
    y: {
      grid: {
        display: true,
      },
    },
  },
  plugins: {
    legend: {
      display: true,
      position: 'bottom',
      align: 'start',
      labels: {
        usePointStyle: true,
        pointStyle: 'circle',
        boxWidth: 6,
        boxHeight: 6,
        font: {
          weight: 'bold',
          size: 12,
        },
        color: '#202020',
      }
    },
    title: {
      display: false,
    },
    tooltip: {
      intersect: false,
      backgroundColor: '#FFF',
      titleColor: '#27294F',
      titleFont: { size: 12 },
      bodyColor: '#000',
      bodyFont: { size: 12 },
      borderColor: function(context) {
        const color = context.tooltipItems?.[0]?.element?.options?.["borderColor"];
        return color || '#fff';
      },
      borderWidth: 2,
      padding: 10,
      cornerRadius: 8,
      displayColors: false,
      callbacks: {
        label: function(context) {
          return formatCurrency(Number(context.raw), 'pt_BR', 'R$');
        }
      }
    }
  }
}

export const doughnutChartDefaultOptions: any = {
  responsive: true,
  maintainAspectRatio: true,
  cutout: '60%',
  plugins: {
    legend: {
      display: true,
      position: 'bottom',
      align: 'start',
      labels: {
        usePointStyle: true,
        pointStyle: 'circle',
        boxWidth: 10,
        boxHeight: 10,
        font: {
          weight: 'bold',
          size: 14,
        },
        color: '#202020',
      }
    },
    title: {display: false},
    tooltip: {
      backgroundColor: '#FFF',
      titleColor: '#27294F',
      titleFont: {size: 12},
      bodyColor: '#000',
      bodyFont: {size: 12},
      borderColor(context: any) {
        const color = context.tooltipItems?.[0]?.element?.options?.["borderColor"];
        return color || '#fff';
      },
      borderWidth: 2,
      padding: 10,
      cornerRadius: 8,
      displayColors: false,
      callbacks: {
        label(context: any) {
          return formatCurrency(Number(context.raw), 'pt_BR', 'R$');
        }
      }
    }
  }
};

export const barChartDefaultOptions: ChartConfiguration["options"] = {
  responsive: true,
  maintainAspectRatio: true,
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
    y: {
      beginAtZero: true,
      grid: {
        display: true,
      },
    },
  },
  plugins: {
    legend: {
      display: true,
      position: 'bottom',
      align: 'start',
      labels: {
        usePointStyle: true,
        pointStyle: 'circle',
        boxWidth: 10,
        boxHeight: 10,
        font: {
          weight: 'bold',
          size: 14,
        },
        color: '#202020',
      }
    },
    title: {
      display: false,
    },
    tooltip: {
      intersect: false,
      backgroundColor: '#FFF',
      titleColor: '#27294F',
      titleFont: { size: 12 },
      bodyColor: '#000',
      bodyFont: { size: 12 },
      borderColor: function(context) {
        const color = context.tooltipItems?.[0]?.element?.options?.["borderColor"];
        return color || '#fff';
      },
      borderWidth: 2,
      padding: 10,
      cornerRadius: 8,
      displayColors: false,
      callbacks: {
        label: function(context) {
          return formatCurrency(Number(context.raw), 'pt_BR', 'R$');
        }
      }
    }
  }
}

export const chartColors: string[] = [
  '#3B82F6', // blue-500
  '#EF4444', // red-500
  '#F59E0B', // amber-500
  '#10B981', // emerald-500
  '#8B5CF6', // violet-500
  '#EC4899', // pink-500
  '#6366F1', // indigo-500
  '#14B8A6', // teal-500
  '#F97316', // orange-500
  '#84CC16', // lime-500
  '#0EA5E9', // sky-500
  '#22C55E', // green-500
  '#EAB308', // yellow-500
  '#A855F7', // purple-500
  '#D946EF', // fuchsia-500
  '#64748B', // slate-500
  '#475569', // slate-600
  '#F43F5E', // rose-500
  '#06B6D4', // cyan-500
  '#93C5FD'  // blue-300
];
